/* @flow */
import * as React from 'react';
import styled from 'styled-components';

import { Flex } from '@sonyged/proc-ui';
import { css } from '@styled-system/css';

import { AGE_BASE, AGE_RANGE } from '../../../../../sushi/rules/sixthYear';
import { ContentScroll } from '../../../../../common/components/ContentScroll';
import type { Customer, Sushi } from '../../../../../sushi/rules/types';
import { StatTable } from './StatTable';
import { SushiContext } from '../../../../../sushi/SushiContext';
import { eatenSushiData } from './constant';
import IconImg from '../../../../../assets/images/pages/sushi/icon_sushi_field_man.svg';

function nameToSushi(name: string): Sushi {
  let [kind, subkind] = name.split('-');
  kind = parseInt(kind);
  subkind = parseInt(subkind);
  return ({ kind, subkind }: any);
}

type Props = {
  customer: Customer,
};

export function EatenSushi(props: Props) {
  let { customer } = props;
  let mapper = React.useContext(SushiContext);
  return (
    <ContentScroll flex={1} minHeight={0} gradientHeight={12}>
      <StatTable>
        <Head>
          <tr>
            <th />
            <th>食べた順番（1皿目→5皿目）</th>
          </tr>
        </Head>
        <Body>
          {eatenSushiData[customer.gender][customer.ageGroup].map((sushi, i) => (
            <tr key={i}>
              <td>
                <Flex alignItems="center">
                  <CustomerAvatar src={IconImg} />
                  <CustomerAge>
                    {AGE_BASE[customer.ageGroup] +
                      Math.floor((Math.sin(i) - Math.floor(Math.sin(i))) * AGE_RANGE[customer.ageGroup])}
                    才
                  </CustomerAge>
                </Flex>
              </td>
              <td>
                <SushiList>
                  {sushi.map((name, j) => (
                    <SushiIcon key={j} src={mapper.getSushiBwIcon(nameToSushi(name))} />
                  ))}
                </SushiList>
              </td>
            </tr>
          ))}
        </Body>
      </StatTable>
    </ContentScroll>
  );
}

const Head = styled('thead')(
  css({
    th: {
      textAlign: 'left',
      px: [12, 12, 16],
      py: [4, 4, 6],
    },
  })
);

const Body = styled('tbody')(
  css({
    td: {
      px: [12, 12, 16],
      color: 'secondary100',
    },
  })
);

const CustomerAvatar = styled('img')(
  css({
    size: [24, 24, 32],
  })
);

const CustomerAge = styled('span')({
  // iPhone SE
  '@media screen and (max-width: 360px)': {
    display: 'none',
  },
});

const SushiList = styled(Flex)(
  css({
    py: [5, 5, 10],
    '> * + *': {
      ml: [10, 10, 24],
    },
  })
);

const SushiIcon = styled('img')(
  css({
    size: [36, 36, 48],
  })
);
